<template>
<div>
<el-card>
  <div slot="header" class="clearfix">
    <span style="color: #409EFF">任务详情</span>
  </div>
  <div>
    <el-row :gutter="6" style="line-height: 33px;">
      <el-col :span="10">
        <span>{{taskDetail.b2cTaskType.taskName}}</span>
      </el-col>
      <el-col :span="4" align="right" class="titleCls">
        <el-avatar shape="square" :size="avatar.size" :src="avatar.img"></el-avatar>
        <span>{{taskDetail.b2cShops.shopName}}</span>
      </el-col>
      <el-col :span="4">
        <el-divider direction="vertical"></el-divider>
        <span>任务编号:{{taskDetail.b2cTaskId}}</span>

      </el-col>
      <el-col :span="3">
        <el-divider direction="vertical"></el-divider>
        <span>{{taskDetail.b2cTasks.createTime}}</span>
      </el-col>
      <el-col :span="3">
        <el-divider direction="vertical"></el-divider>
        <span>状态:{{avatar.status}}</span>
      </el-col>
    </el-row>
    <hr/>
    <el-row :gutter="0" style="line-height: 33px;">
      <el-col :span="24" class="lineCls">
        <span>任务生产订单总数: {{taskOrders.totalAllOrderNum}}单</span>
        <el-divider direction="vertical"></el-divider>
        <span>待放出: {{getOrderNumWithStatus(202109020001) != null ? getOrderNumWithStatus(202109020001).orderNums : 0}}单</span>
        <el-divider direction="vertical"></el-divider>
        <span>待接单: {{getOrderNumWithStatus(202109010001) != null ? getOrderNumWithStatus(202109010001).orderNums : 0}}单</span>
        <el-divider direction="vertical"></el-divider>
        <span>待操作: {{getOrderNumWithStatus(202109020002) != null ? getOrderNumWithStatus(202109020002).orderNums : 0}}单</span>
        <el-divider direction="vertical"></el-divider>
        <span>发货返款: {{getOrderNumWithStatus(202110040002) != null ? getOrderNumWithStatus(202110040002).orderNums : 0}}单</span>
        <el-divider direction="vertical"></el-divider>
        <span>待评价: {{getOrderNumWithStatus(202109030002) != null ? getOrderNumWithStatus(202109030002).orderNums : 0}}单</span>
        <el-divider direction="vertical"></el-divider>
        <span>待确认: {{getOrderNumWithStatus(202109030003) != null ? getOrderNumWithStatus(202109030003).orderNums : 0}}单</span>
        <el-divider direction="vertical"></el-divider>
        <span>已完成: {{getOrderNumWithStatus(202109030004) != null ? getOrderNumWithStatus(202109030004).orderNums : 0}}单</span>
        <el-divider direction="vertical"></el-divider>
        <span>已撤销: {{getOrderNumWithStatus(202109030005) != null ? getOrderNumWithStatus(202109030005).orderNums : 0}}单</span>
      </el-col>
    </el-row>
  </div>

  <el-tabs class="el-tabs-self" type="border-card" v-model="tabsActive">
    <el-tab-pane v-for="(item, index) in tabsActives" :key="index" :label="item.lable" :name="item.value+''"></el-tab-pane>
  </el-tabs>
  <component :is="curtTabCompnents[tabsActive]" :tableFeildAndVal="curtTabComPropes[tabsActive]" :orderCondition="{taskId:taskDetail.b2cTaskId, status:tabsActives[tabsActive].value}"></component>
</el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import TaskDetailComponent from  './TaskDetailComponent';
import FreePriceDetailComponent from './FreePriceDetailComponent';
import DoItOrderComponent from './DoItOrderComponent';
import {getTaskDetail, queryTaskOrder} from "../../api/b2cbusiness/b2c_tasklist";
import {isStrEmpty} from "@/lib/utils";

export default {
  name: "BusinessTaskDetail",
  mixins:[MixinCUD],
  components: {
    TaskDetailComponent,
    FreePriceDetailComponent,
    DoItOrderComponent
  },
  data(){
    return {
      taskDetail:{
      },
      taskOrders:{
      },
      avatar:{
        img:"https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        size:"small",
        shopName: "q点数码旗舰店",
        taskNum:"890288",
        dateTime: "2021/6/15 19:35:06 ",
        status: "进行中",
        typeName: "手机淘宝无截图版"
      },
      taskData:{
        total: 3,
        waitSerOrder: 0,
        waitReciveOrder: 0,
        waitOptOrder: 1,
        deliverRetPrice: 2,
        waitReview: 0,
        waitCoform: 0,
        alreadyFinish: 0,
        recallOrder: 0
      },
      tableData:[
        {
          orderNum:3,
          image:"https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
          productTitle:"华为小米手机适用智能儿童电话手表防水时尚户外全网通小学生天才男女孩定位可插卡4G正品多功能超长待机",
        }

      ],
      tabsActive: 1,
      tabsActives: {
        1:{
          lable:"任务详情",
          value: 1
        },
        2:{
          lable: "费用详情",
          value: 2
        },
        3:{
          lable: "进行中的订单",
          value: 3
        },
        4:{
          lable: "已完成订单",
          value: 4
        },
        5:{
          lable: "已撤销订单",
          value: 5
        },
        6:{
          lable: "待接订单",
          value: 6
        },
        7:{
          lable: "追评订单",
          value: 7
        },
        8:{
          lable: "全部订单",
          value: 8
        }
      },
      curtTabCompnents:{
        1:"TaskDetailComponent",
        2:"FreePriceDetailComponent",
        3:"DoItOrderComponent",
        4:"DoItOrderComponent",
        5:"DoItOrderComponent",
        6:"DoItOrderComponent",
        7:"DoItOrderComponent",
        8:"DoItOrderComponent"
      },
      curtTabComPropes: {
        3:[
      {
        key: "beginTime",
        lable: "接单时间"
      },
      {
        key: "orderId",
        lable: "订单ID"
      },
      {
        key: "customerId",
        lable: "买手ID"
      },
      {
        key: "orderInfo",
        lable: "接单信息"
      },
      {
        key: "moneyInfo",
        lable: "费用"
      },
      {
        key: "statusStr",
        lable: "订单状态"
      }
    ],
        4:[
          {
            key: "beginTime",
            lable: "完成时间"
          },
          {
            key: "orderId",
            lable: "订单ID"
          },
          {
            key: "customerId",
            lable: "买手ID"
          },
          {
            key: "reciveOrderInfo",
            lable: "接单信息"
          },
          {
            key: "moneyInfo",
            lable: "费用"
          },
          {
            key: "statusStr",
            lable: "订单状态"
          }
        ],
        5:[
          {
            key: "beginTime",
            lable: "撤销时间"
          },
          {
            key: "orderId",
            lable: "订单ID"
          },
          {
            key: "customerId",
            lable: "买手ID"
          },
          {
            key: "reciveOrderInfo",
            lable: "接单信息"
          },
          {
            key: "moneyInfo",
            lable: "费用"
          },
          {
            key: "statusStr",
            lable: "订单状态"
          }
        ],
        6:[
          {
            key: "orderId",
            lable: "订单ID"
          },
          {
            key: "customerId",
            lable: "买手ID"
          },
          {
            key: "reciveOrderInfo",
            lable: "接单信息"
          },
          {
            key: "moneyInfo",
            lable: "费用"
          },
          {
            key: "statusStr",
            lable: "订单状态"
          }
        ],
        7:[
          {
            key: "beginTime",
            lable: "追评发起时间"
          },
          {
            key: "orderId",
            lable: "订单ID"
          },
          {
            key: "customerId",
            lable: "买手ID"
          },
          {
            key: "reciveOrderInfo",
            lable: "接单信息"
          },
          {
            key: "moneyInfo",
            lable: "费用"
          },
          {
            key: "statusStr",
            lable: "订单状态"
          }
        ],
        8:[
          {
            key: "beginTime",
            lable: "接单时间"
          },
          {
            key: "orderId",
            lable: "订单ID"
          },
          {
            key: "customerId",
            lable: "买手ID"
          },
          {
            key: "reciveOrderInfo",
            lable: "接单信息"
          },
          {
            key: "moneyInfo",
            lable: "费用"
          },
          {
            key: "statusStr",
            lable: "订单状态"
          }
        ],
      }
    }
  },
  mounted() {
    //新增详情保留orderId
    if (!isStrEmpty(this.$route.query.b2cTaskId)){
      sessionStorage.setItem("b2cTaskId", this.$route.query.b2cTaskId);
    }
    getTaskDetail(isStrEmpty(this.$route.query.b2cTaskId)?sessionStorage.getItem("b2cTaskId"):this.$route.query.b2cTaskId).then(res=>{
      //console.log(res.data)
      if (res.success){
        this.taskDetail = res.data;
        this.curtTabComPropes[1] = res.data;
      }
    });
    this.curtTabComPropes[2] = this.$route.query.b2cTaskId;

    queryTaskOrder(isStrEmpty(this.$route.query.b2cTaskId)?sessionStorage.getItem("b2cTaskId"):this.$route.query.b2cTaskId).then(res=>{
      if (res.success){
        this.taskOrders = res.data;
      }
    });
  },
  activated() {
    getTaskDetail(isStrEmpty(this.$route.query.b2cTaskId)?sessionStorage.getItem("b2cTaskId"):this.$route.query.b2cTaskId).then(res=>{
      console.log(res.data)
      if (res.success){
        this.taskDetail = res.data;
        this.curtTabComPropes[1] = res.data;
      }
    });
    this.curtTabComPropes[2] = isStrEmpty(this.$route.query.b2cTaskId)?sessionStorage.getItem("b2cTaskId"):this.$route.query.b2cTaskId;

    queryTaskOrder(isStrEmpty(this.$route.query.b2cTaskId)?sessionStorage.getItem("b2cTaskId"):this.$route.query.b2cTaskId).then(res=>{
      if (res.success){
        this.taskOrders = res.data;
      }
    });
    this.$forceUpdate();
  },
  methods: {
  },
  computed:{
    getOrderNumWithStatus(){
      return function (status) {
        for (let item in this.taskOrders.businessOrderStatusNums){
          console.log(this.taskOrders.businessOrderStatusNums[item])
          if (this.taskOrders.businessOrderStatusNums[item].status == status){
            return this.taskOrders.businessOrderStatusNums[item];
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.titleCls{
  line-height: 30px;
  position: relative;
}

.titleCls span{
  vertical-align: middle;
  margin-left: 1em;
}

.lineCls{
  line-height: 28px;
  font-size: 0.9rem;
  color: #acacac;
}

.lineCls span{
  margin: 0.6rem;
  margin-left: 0;
}

.demo-input-suffix {
  margin-bottom: 15px;
}

.el-tabs-self{
  position: relative;
  width: 100%;
  margin-top: 10px;
}

span{
  text-align: center;
}
.tb-edit .el-input {
  display: none
}
.tb-edit .current-row .el-input {
  display: block
}
.tb-edit .current-row .el-input+span {
  display: none
}
</style>
